export const MESSAGES_READ_EVENT = "messages-read";

export const messageUserId = (user) => user?.id ?? user?.userId;

export const messageUserName = (user) => {
	if (!user) return "—";
	return (
		[user.firstName, user.lastName].filter(Boolean).join(" ") ||
		user.userName ||
		user.name ||
		"—"
	);
};

export const conversationDisplayName = (conversation, currentUserId) => {
	if (!conversation) return "";
	if (conversation.name) return conversation.name;
	if (!currentUserId) return "—";
	const other = (conversation.participants || []).find((participant) => {
		const id = messageUserId(participant);
		return (
			id && String(id).toLowerCase() !== String(currentUserId).toLowerCase()
		);
	});
	return messageUserName(other);
};
